import { Module } from "wrapper6";
import { hasClass } from "../utils/_class-handlers";

var $ = jQuery;

export default class Search extends Module {

    ready(app) {

        // If is search page
        if (hasClass(document.body, 'search')) {

            const RESULT_CONTAINER = $('.mtt-search-results');

            // If search param is set
            if (RESULT_CONTAINER.length && checkForUrlParam('s')) {
                
                // Animate to top
                $('html, body').animate({ 
                    scrollTop: RESULT_CONTAINER.offset().top - 130
                }, 800);
            }
        }

        function checkForUrlParam(param) {
            const URL = window.location.href;
            if (URL.indexOf('?' + param + '=') != -1)
                return true;
            else if (URL.indexOf('&' + param + '=') != -1)
                return true;
            return false
        }
    }
}